<template>
  <div>
    <el-row :data="titleData">
      <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="{ span: 12, offset: 0 }">
        <ul>
          <li>供&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;应&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;商：{{ titleData[0].GYS_NAME }}</li>
          <li>送&nbsp;&nbsp;货&nbsp;&nbsp;日&nbsp;&nbsp;期：{{ titleData[0].SEND_DAY }}</li>
        </ul>
      </el-col>
      <el-col :xs="12" :sm="12" :md="12" :lg="{ span: 12, offset: 0 }" :xl="{ span: 12, offset: 0 }">
        <ul>
          <li>订&nbsp;&nbsp;&nbsp;&nbsp;单&nbsp;&nbsp;&nbsp;&nbsp;编&nbsp;&nbsp;&nbsp;&nbsp;码：{{ titleData[0].ORDER_CODE }}
          </li>
          <li>订&nbsp;&nbsp;单&nbsp;&nbsp;总&nbsp;&nbsp;金&nbsp;&nbsp;额：{{ titleData[0].TOTAL_GYS_FEE }}</li>
        </ul>
      </el-col>
    </el-row>
    <!-- <el-row style="margin-top: 10px">
      <el-form size="small" :inline="true" class="demo-form-inline" style="margin: 0;" :model="searchForm"
        :ref="searchForm" @submit.native.prevent>
        <el-col>
          <el-form-item label="产品名称：">
            <el-autocomplete class="inline-input" v-model="searchForm.productName" :fetch-suggestions="querySearch"
              placeholder="请输入产品名称" :trigger-on-focus="false" @select="handleSelect" clearable></el-autocomplete>
          </el-form-item>
        </el-col>
      </el-form>
    </el-row> -->
    <el-row>
      <el-col :span="24">
        <el-table :data="tableData" stripe border style="width: 100%" :span-method="objectSpanMethod">
          <el-table-column type="index" label="序号" width="50" :index="indexMethod"></el-table-column>
          <el-table-column label="产品编码" prop="PRODUCT_CODE"></el-table-column>
          <el-table-column prop="PRODUCT_NAME" label="产品" width="200" min-width="80"></el-table-column>
          <el-table-column prop="TYPE_UNIT" label="单位" min-width="45"></el-table-column>
          <el-table-column prop="REAL_PRICE" label="单价" min-width="45"></el-table-column>
          <el-table-column prop="PRODUCT_COUNT" label="订单数量" min-width="60"></el-table-column>
          <el-table-column prop="CUSTOMER_NEED_COUNT" label="供应商送货总数量" min-width="60"></el-table-column>
          <el-table-column prop="REAL_COUNT" label="验收总数量" width="150" min-width="60">
            <template slot-scope="scope">
              <el-row>
                <el-col :span="24">
                  <el-input size="small" v-model="scope.row.REAL_COUNT" :placeholder="scope.row.PRODUCT_COUNT" @focus="getColumnRow(scope.row)"
                    @change="setActualNumber" clearable disabled></el-input>
                </el-col>
              </el-row>
            </template>
          </el-table-column>
          <el-table-column label="验收总价" min-width="45">
            <template slot-scope="scope">
              {{ setTotalFee(scope.row) }}
            </template>
          </el-table-column>
          <el-table-column prop="PRODUCT_COMMENT" label="备注" min-width="80"></el-table-column>
          <el-table-column prop="TC_NAME" label="公司名称" min-width="80"></el-table-column>
          <el-table-column prop="DK_NAME" label="项目点-档口" min-width="80"></el-table-column>
          <el-table-column prop="CUSTOMER_PRODUCT_COUNT" label="客户订购数量" min-width="80"></el-table-column>
          <el-table-column prop="CUSTOMER_NEED_COUNT" label="供应商送货数量" min-width="80"></el-table-column>
          <el-table-column prop="PSZX_REAL_COUNT" label="验收数量" min-width="80">
            <template slot-scope="scope">
              <el-row>
                <el-col :span="24">
                  <el-input size="small" v-model="scope.row.PSZX_REAL_COUNT" :placeholder="scope.row.CUSTOMER_REAL_COUNT" clearable
                    :disabled="isAcceptByTcQuantity == 1" @change="setActualNumber" @focus="getColumnRow(scope.row)">
                  </el-input>
                </el-col>
              </el-row>
            </template>
          </el-table-column>
          <el-table-column prop="CUSTOMER_PRODUCT_COMMENT" label="客户备注" min-width="80"></el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row style="margin-top:20px">
      <el-col :xl="{ span: 1, offset: 22 }" :lg="{ span: 1, offset: 22 }" :md="{ span: 2, offset: 21 }" style="padding-left:4px">
        <el-button size="small" :disabled="isDisabled" @click="distributionCenterAcceptance1()" v-if="isAcceptByTcQuantity == 1">全部确认</el-button>
        <el-button size="small" :disabled="isDisabled" @click="__confirm()" v-else>全部确认</el-button>
      </el-col>
    </el-row>
    <el-dialog title="提示" :visible.sync="tableVisible" width="50%" center>
      <p style="color: red">下列为实收数量与客户实收数量不一致的产品，请再次确认</p>
      <el-table :data="arrData" stripe border style="width: 100%">
        <!-- <el-table :data="changeProducts" stripe border style="width: 100%"> -->
        <el-table-column type="index" label="序号" width="50"></el-table-column>
        <el-table-column prop="PRODUCT_NAME" label="产品" width="200"></el-table-column>
        <el-table-column prop="TYPE_UNIT" label="单位" min-width="45"></el-table-column>
        <el-table-column prop="DK_NAME" label="项目点-档口" width="200"></el-table-column>
        <el-table-column prop="CUSTOMER_PRODUCT_COUNT" label="客户订单数量" width="120" min-width="45"></el-table-column>
        <el-table-column prop="CUSTOMER_REAL_COUNT" label="客户验收数量" width="120" min-width="60"></el-table-column>
        <el-table-column prop="PSZX_REAL_COUNT" label="实收数量" width="100"></el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="close()">取 消</el-button>
        <el-button size="small" type="primary" @click="distributionCenterAcceptance2()">确 定</el-button>
      </span>
    </el-dialog>
    <!-- <el-dialog title="新增产品" center :visible.sync="addFormVisible" width="600px">
      <el-form :model="addForm" ref="addForm" size="small">
        <el-form-item label="产品名称：" :label-width="formLabelWidth">
          <span>{{ this.addForm.NAME }}</span>
        </el-form-item>
        <el-form-item label="单位：" :label-width="formLabelWidth">
          <label slot="label">单&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;位：</label>
          <span>{{ this.addForm.TYPE_UNIT }}</span>
        </el-form-item>
        <el-form-item label="单价：" :label-width="formLabelWidth">
          <label slot="label">单&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;价：</label>
          <el-input v-model="addForm.CURRENT_PRICE" v-if="BE_PRICE === 1" @change="countTotal"></el-input>
          <el-input v-model="addForm.CURRENT_PRICE" v-else disabled @change="countTotal"></el-input>
        </el-form-item>
        <el-form-item label="订购数量：" :label-width="formLabelWidth">
          <el-input v-model="addForm.count" @change="countTotal"></el-input>
        </el-form-item>
        <el-form-item label="总金额：" :label-width="formLabelWidth">
          <el-input v-model="addForm.totalFee" @change="countPrice"></el-input>
        </el-form-item>
        <el-form-item label="备注：" :label-width="formLabelWidth">
          <label slot="label">备&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;注：</label>
          <el-input v-model="addForm.comment" maxlength="20" show-word-limit></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="addFormClose">取 消</el-button>
        <el-button size="small" @click="submitAdd">确 定</el-button>
      </div>
    </el-dialog> -->
  </div>
</template>
<script>
import {
  // queryOrderDetailFun,
  addOrderListFun, chooseEntryFun,
} from 'api/shopOrderManage';
import http from '@/assets/common/http';
import util from '../../assets/common/util';

export default {
  data() {
    return {
      fromName: ['s_NewOrderList'],
      toName: [],
      addForm: {},
      addFormVisible: false,
      searchForm: {},
      tableData: [],
      formLabelWidth: '120px',
      BE_PRICE: Number(sessionStorage.getItem('BE_PRICE')),
      productArray: [],
      titleData: [{
        SUPPLIER_NAME: '',
        SEND_DAY: '',
        ORDER_CODE: '',
        TOTAL_GYS_FEE: '',
      }],
      detailDate: [],
      detailStatus: true,
      isDisabled: false,
      tableVisible: false,
      currentCount: 0,
      productID: 0,
      changeProducts: [],
      TOTAL_FEE: 0,
      REAL_FEE: 0,
      TC_ID: sessionStorage.getItem('companyId'),
      OTYPE: 0,
      arrData: [],
      currentUnit: '',
      repeatedRecords: [],
      rids: [],
      rcounts: [],
      purchaseDetailIDList: [],
      isAcceptByTcQuantity: sessionStorage.getItem('IS_ACCEPT_BY_TC_QUANTITY'),
      tcNameList: [],
      tcNameRids: [],
      tcNameRcounts: [],
    };
  },
  beforeRouteLeave(to, from, next) {
    // 离开页面前清除订单ID
    if (!this.toName.includes(to.name)) {
      sessionStorage.removeItem('orderId');
    }
    next();
  },
  beforeRouteEnter(to, from, next) {
    next((that) => {
      // 判断是否通过修改URL进入
      if (!that.fromName.includes(from.name) || !sessionStorage.getItem('orderId')) {
        that.$message.show({ text: '请从待送订单进入配送中心验收', type: 'warning' });
        that.$router.go(-1);
      } else {
        that.getOrderDetailList();
      }
    });
  },
  methods: {
    querySearch(queryString, callback) {
      this.$_getSearchRushOrderList(queryString).then((res) => {
        const tmpArr = res.map((item) => ({
          BRAND: item.BRAND,
          CURRENT_PRICE: item.CURRENT_PRICE,
          ID: item.ID,
          INNER_CODE: item.INNER_CODE,
          NAME: item.NAME,
          TYPE_UNIT: item.TYPE_UNIT,
          value: item.value,
          count: 0,
          totalFee: 0,
        }));
        const results = tmpArr.map((item) => {
          // item.value = item.NAME
          item.value = `${item.NAME}(${item.TYPE_UNIT})`;
          return item;
        });
        callback(results);
      });
    },
    //  点击搜索结果返回选中的结果
    handleSelect(item) {
      this.addForm = item;
      this.PRODUCT_NAME = item.NAME;
      this.TYPE_UNIT = item.TYPE_UNIT;
      this.addFormVisible = true;
    },
    // 搜索接口调用
    $_getSearchRushOrderList(NAME) {
      const data = {
        PRODUCT_NAME: this.searchForm.productName,
        ORDER_ID: Number(sessionStorage.getItem('orderId')),
        SUPPLIER_ID: Number(sessionStorage.getItem('supplierId')),
        PROJECT_ID: Number(sessionStorage.getItem('projectId')),
        SEND_DAY: this.titleData[0].SEND_DAY,
      };
      return new Promise((resolve, reject) => {
        chooseEntryFun(data).then((res) => {
          if (res.length === 0) {
            this.$message.show({ text: '暂无数据', type: 'success' });
          } else {
            resolve(res[0].list);
            // resolve(res)
          }
        }).catch((err) => {
          reject(err);
        });
      });
    },
    addFormClose() {
      this.addFormVisible = false;
    },
    // ---------------------------添加·产品·确认·按钮
    submitAdd() {
      this.addOrderProduct();
    },
    addOrderProduct() {
      if (document.body.style.cursor === 'wait') {
      } else {
        document.body.style.cursor = 'wait';
        try {
          const reg = /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/;
          if (!reg.test(this.addForm.CURRENT_PRICE) || this.addForm.CURRENT_PRICE <= 0) {
            this.$message.show({ text: '请输入正数单价', type: 'warning' });
            document.body.style.cursor = 'default';
            return false;
          }
          if (!reg.test(this.addForm.count) || this.addForm.count <= 0) {
            this.$message.show({ text: '请输入订购数量', type: 'warning' });
            document.body.style.cursor = 'default';
            return false;
          }
          if (!util.JudgmentUnit(this.addForm.TYPE_UNIT)) { // 如果不是
            const beInter = (this.addForm.count % 1 === 0);
            if (beInter == false) {
              this.$message.show({ text: '单位不是KG的，只能输入整数', type: 'warning' });
              document.body.style.cursor = 'default';
              return false;
            }
          } else {
            document.body.style.cursor = 'default';
          }
          const params = {
            ORDER_ID: Number(sessionStorage.getItem('orderId')),
            PRODUCT_COUNT: Number(this.addForm.count),
            PRODUCT_CODE: this.addForm.INNER_CODE,
            PRODUCT_FEE: Number(this.addForm.totalFee),
          };
          if (this.addForm.CURRENT_PRICE) {
            params.PRICE = Number(this.addForm.CURRENT_PRICE);
          }
          if (this.addForm.comment) {
            params.PRODUCT_COMMENT = this.addForm.comment;
          }
          addOrderListFun(params).then((result) => {
            this.addFormVisible = false;
            this.$message.show({ text: '新增成功', type: 'success' });
            this.searchForm.productName = '';
            this.getOrderDetailList();
            this.changeProducts = [];
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            document.body.style.cursor = 'default';
          });
        } finally {}
      }
    },
    // ---------------------------------------------------------------拉取数据
    getOrderDetailList() {
      const params = {
        SERVICE_ID: '10003',
        OTYPE: 44,
        ORDER_ID: sessionStorage.getItem('orderId'),
      };
      http.post(params).then((res) => {
        this.purchaseDetailIDList = [];
        this.titleData = res[0].TITLE;
        this.detailDate = res[0].DETAIL;
        this.tableData = res[0].DETAIL.map((item) => Object.assign(item, { PSZX_REAL_COUNT: item.CUSTOMER_REAL_COUNT }));
        this.productArray = this.tableData.map((item) => ({ REAL_COUNT: Number(item.PRODUCT_COUNT), PRODUCT_COUNT: Number(item.PRODUCT_COUNT), ORDER_DETAIL_ID: item.ORDER_DETAIL_ID }));
        this.purchaseDetailIDList = res[0].DETAIL.map((item) => item.PURCHASE_DETAIL_ID);
        this.tcNameList = res[0].DETAIL.map((item) => JSON.stringify({ PURCHASE_DETAIL_ID: item.PURCHASE_DETAIL_ID, TC_NAME: item.TC_NAME }));
        this.isRepeated();
        this.calTotal();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    getColumnRow(row) {
      this.currentCount = row.PRODUCT_COUNT;
      this.productID = row.ORDER_DETAIL_ID;
      this.currentUnit = row.TYPE_UNIT;
      this.purchaseDetailID = row.PURCHASE_DETAIL_ID;
    },
    // ---------------------------设置当前产品的实收数量
    currentActualNumber(row) {
      return row.PRODUCT_COUNT;
    },
    // ----------------------------改变实收数量触发
    setActualNumber(count) {
      if (!(/^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/.test(count))) {
        this.isDisabled = true;
        this.$message.show({ text: '请输入正数实收数量', type: 'error' });
        return false;
      }
      if (!util.JudgmentUnit(this.currentUnit)) {
        const beInter = (Number(count) % 1 === 0);
        if (beInter == false) {
          this.isDisabled = true;
          this.$message.show({ text: '单位不是KG的，只能输入整数', type: 'error' });
          return false;
        }
      }
      this.isDisabled = false;
      this.productArray.forEach((item) => {
        if (item.ORDER_DETAIL_ID === this.productID && Number(item.PSZX_REAL_COUNT) !== Number(count)) {
          item.PSZX_REAL_COUNT = Number(count);
          this.prepareChangeData(count);
        }
      });
    },
    // -------------------------------准备改变的数据
    prepareChangeData(count) {
      count = Number(count);
      const data = this.tableData.filter((item) => item.ORDER_DETAIL_ID === this.productID);
      this.changeProducts.push(...data);
      for (let i = 0, len = this.changeProducts.length; i < len; i++) {
        const item = this.changeProducts[i];
        if (item.ORDER_DETAIL_ID === this.productID) {
          item.PSZX_REAL_COUNT = count;
          // item.TOTAL_FEE = Math.round(count * Number(item.REAL_PRICE) * 100) / 100;
          break;
        }
      }
      this.calTotal();
    },
    // -----------------------------------设置验收总价
    setTotalFee(row) {
      return row.TOTAL_FEE;
    },
    // -----------------------------------全部确认
    __confirm() {
      for (let i = 0; i < this.detailDate.length; i++) {
        if (this.detailDate[i].GYS_PRICE == 0) {
          this.detailStatus = false;
        }
      }
      if (this.changeProducts.length !== 0 && this.detailStatus == true) {
        this.arrData = this.changeProducts.filter((ele, index, self) => self.indexOf(ele) === index);
        this.tableVisible = true;
      } else if (this.detailStatus == true) {
        this.distributionCenterAcceptance2();
      } else if (this.detailStatus == false) {
        this.$message.show({ text: '单价不能为零，无法验收', type: 'warning' });
      }
    },
    // ------------------------------------确认按钮
    distributionCenterAcceptance1() {
      if (document.body.style.cursor === 'wait') {
      } else {
        document.body.style.cursor = 'wait';
        try {
          const submitArr = this.tableData.map((item, index) => ({
            PURCHASE_DETAIL_ID: Number(item.PURCHASE_DETAIL_ID),
            PRODUCT_CODE: item.PRODUCT_CODE,
            NEW_COUNT: Number(item.REAL_COUNT),
          }));
          const params = {
            SERVICE_ID: '15064',
            OTYPE: 3,
            GYS_ID: Number(sessionStorage.getItem('tcId')),
            PURCHASE_ORDER_ID: sessionStorage.getItem('orderId'),
            PRODUCT_ARRAY: submitArr,
          };
          http.post(params).then((result) => {
            if (result) {
              this.$message.show({ text: '确认成功', type: 'success' });
              this.$router.push({ name: 's_NewOrderList' });
              document.body.style.cursor = 'default';
            } else {
              document.body.style.cursor = 'default';
            }
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            document.body.style.cursor = 'default';
          });
        } finally {}
      }
    },
    distributionCenterAcceptance2() {
      if (document.body.style.cursor === 'wait') {
      } else {
        document.body.style.cursor = 'wait';
        try {
          const tmpSet = new Set(this.purchaseDetailIDList);
          const PRODUCT_ARRAY = [];
          tmpSet.forEach((item1) => {
            const CUSTOMER_REAL_COUNT_ARRAY = this.tableData.filter((item2) => item2.PURCHASE_DETAIL_ID == item1).map((item3) => ({
              RELATION_ID: Number(item3.RELATION_ID),
              PSZX_REAL_COUNT: item3.PSZX_REAL_COUNT,
            }));
            const tmp = this.tableData.find((item4) => item4.PURCHASE_DETAIL_ID == item1);
            PRODUCT_ARRAY.push({
              PRUCHASE_REAL_COUNT: Number(tmp.REAL_COUNT),
              PURCHASE_DETAIL_ID: item1,
              TYPE_UNIT: tmp.TYPE_UNIT,
              CUSTOMER_REAL_COUNT_ARRAY,
            });
          });
          const params = {
            SERVICE_ID: '15064',
            OTYPE: 4,
            PURCHASE_ORDER_ID: sessionStorage.getItem('orderId'),
            PRODUCT_ARRAY,
          };


          http.post(params).then((result) => {
            if (result) {
              this.$message.show({ text: '确认成功', type: 'success' });
              this.$router.push({ name: 's_NewOrderList' });
              document.body.style.cursor = 'default';
            } else {
              document.body.style.cursor = 'default';
            }
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            document.body.style.cursor = 'default';
          });
        } finally {
          document.body.style.cursor = 'default';
        }
      }
    },
    close() {
      this.tableVisible = false;
    },
    countTotal() {
      this.addForm.totalFee = Math.round((this.addForm.CURRENT_PRICE * this.addForm.count) * 100) / 100;
    },
    countPrice() {
      this.addForm.CURRENT_PRICE = Math.round((this.addForm.totalFee / this.addForm.count) * 100) / 100;
    },
    objectSpanMethod({
      row, column, rowIndex, columnIndex,
    }) {
      const tmpSet = new Set(this.purchaseDetailIDList);
      if (tmpSet.size != this.purchaseDetailIDList.length) {
        if (['序号', '产品编码', '产品', '单位', '单价', '订单数量', '供应商送货总数量', '验收总数量', '验收总价', '备注', '公司名称'].includes(column.label)) {
          if (column.label == '公司名称') {
            if (this.tcNameRids.includes(rowIndex)) {
              return {
                rowspan: this.tcNameRcounts[this.tcNameRids.indexOf(rowIndex)],
                colspan: 1,
              };
            }
            return {
              rowspan: 0,
              colspan: 0,
            };
          }
          if (this.rids.includes(rowIndex)) {
            return {
              rowspan: this.rcounts[this.rids.indexOf(rowIndex)],
              colspan: 1,
            };
          }
          return {
            rowspan: 0,
            colspan: 0,
          };
        }
      }
    },
    isRepeated() {
      const tmpSet = new Set(this.purchaseDetailIDList);
      if (tmpSet.size != this.purchaseDetailIDList.length) {
        tmpSet.forEach((item1) => {
          let i = 0;
          this.purchaseDetailIDList.forEach((item2) => {
            if (item1 == item2) { i++; }
          });
          this.rids.push(this.purchaseDetailIDList.indexOf(item1));
          this.rcounts.push(i);
        });
      }
      const tmpSet2 = new Set(this.tcNameList);
      if (tmpSet2.size != this.tcNameList.length) {
        tmpSet2.forEach((item1) => {
          let i = 0;
          this.tcNameList.forEach((item2) => {
            if (item1 == item2) { i++; }
          });
          this.tcNameRids.push(this.tcNameList.indexOf(item1));
          this.tcNameRcounts.push(i);
        });
      }
    },
    calTotal() {
      const tmpObj = {};
      this.purchaseDetailIDList.forEach((item) => {
        tmpObj[item] = { totalCount: 0, totalFee: 0 };
      });
      this.tableData.forEach((item) => {
        tmpObj[item.PURCHASE_DETAIL_ID].totalCount += Number(item.PSZX_REAL_COUNT);
        tmpObj[item.PURCHASE_DETAIL_ID].totalFee += Number(item.PSZX_REAL_COUNT) * Number(item.REAL_PRICE);
      });
      this.tableData = this.tableData.map((item) => Object.assign(item, {
        REAL_COUNT: tmpObj[item.PURCHASE_DETAIL_ID].totalCount,
        TOTAL_FEE: tmpObj[item.PURCHASE_DETAIL_ID].totalFee.toFixed(2),
      }));
    },
    indexMethod(index) {
      return [...new Set(this.purchaseDetailIDList)].indexOf(this.tableData[index].PURCHASE_DETAIL_ID) + 1;
    },
  },
};
</script>
<style scoped>
ul {
  list-style: none;
  min-height: 50px;
  padding: 0;
}

li {
  margin-bottom: 0;
  line-height: 25px;
  font-size: 16px;
}

p {
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/shopOrderManage/s_distributionCenterOrderCheck.vue